import { AlertModal } from '@monorepo/shared/componentsV2/modals/AlertModal';
import React from 'react';

type ModalProps = {
  open: boolean;
  onDone: () => void;
};

export const CannotEditFormTemplateModal = (props: ModalProps) => {
  const { open, onDone } = props;
  return (
    <AlertModal
      title="Cannot Configure Form"
      description={
        <>
          <b>This form is locked for editing.</b>
          <br />
          It is currently shared across multiple organizations or sites where
          you lack admin permissions.
          <br />
          <br />
          To make changes, please contact your Organization Admin or Customer
          Success Manager to request an editable copy.
        </>
      }
      open={open}
      onDone={onDone}
    />
  );
};
